<template>
  <div class="d-flex flex-column align-items-start mt-2 pb-2 color-white">
    <div class="container text-left mt-2 mb-2 text-playgame">{{value.gameName}}</div>
    <div class="`d-flex w-100"
    :class="!value.boardImg && 'd-none' ">
      <img class="p-2 w-100 h-100" width="100%" :src="value.boardImg" alt="6cards_board" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-header',
  props: {
    value: Object,
  },
};
</script>
